import PropTypes from "prop-types";
import React from "react";
import CustomButton from "./mantineCustomComponents/CustomButton";

const PortfolioCollectionToggle = ({ isPortfolioCollection, onToggle }) => {
  return (
    <CustomButton
      text={
        isPortfolioCollection
          ? "Disable Portfolio Collection"
          : "Enable Portfolio Collection"
      }
      componentClasses="link"
      variant="transparent"
      type="button"
      onClick={onToggle}
    />
  );
};

PortfolioCollectionToggle.propTypes = {
  isPortfolioCollection: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default PortfolioCollectionToggle;
